module.exports = __webpack_public_path__ + "img/green_logo.ed0ef8e5.png";